export default __webpack_public_path__ + "static/media/champions-medal.0113a52e.svg";